import { FC, useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import './DealMaterialsList.sass';

import { useSelector } from '@/api/state';
import { getDeal } from '@/utils/stateAccessors';
import ResponsiveViewWrapper from '@payaca/components/responsiveViewWrapper/ResponsiveViewWrapper';
import * as dealsActions from '@payaca/store/deals/dealsActions';
import { useMaterialsList } from '@payaca/store/hooks/appState';
import * as materialsListActions from '@payaca/store/materialsList/materialsListActions';
import DealCostsMargins from '../dealCostsMargins/DealCostsMargins';
import ManageableMaterialsList from '../manageableMaterialsList/ManageableMaterialsList';

interface Props {
  dealId: number;
  enablePurchaseBehaviour?: boolean;
}

const DealMaterialsList: FC<Props> = ({
  dealId,
  enablePurchaseBehaviour = true,
}: Props) => {
  const dispatch = useDispatch();

  const deal = useSelector((state) => getDeal(state, dealId));

  const materialsList = useMaterialsList(deal?.materialsListId);

  const handleCreateDealMaterialsList = useCallback(() => {
    dispatch(
      materialsListActions.requestCreateDealMaterialsList(
        dealId,
        (materialsListId: number) => {
          dispatch(dealsActions.requestGetDeal(dealId));
        }
      )
    );
    // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useCallback has a missing dependency: 'dispatch'
  }, [dealId]);

  const handleGetMaterialsListWithRelatedEntities = useCallback(
    (materialsListId: number) => {
      dispatch(
        materialsListActions.requestGetMaterialsListWithRelatedEntities(
          materialsListId
        )
      );
    },
    // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useCallback has a missing dependency: 'dispatch'
    []
  );

  useEffect(() => {
    if (deal) {
      if (!deal.materialsListId) {
        handleCreateDealMaterialsList();
      } else {
        handleGetMaterialsListWithRelatedEntities(deal.materialsListId);
      }
    }
    // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useEffect has missing dependencies: 'handleCreateDealMaterialsList', 'handleGetMaterialsListWithRelatedEntities', and 'deal'
  }, [deal?.materialsListId]);

  useEffect(() => {
    dispatch(dealsActions.requestGetDeal(dealId));
    // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useEffect has a missing dependency: 'dispatch'
  }, [dealId]);

  const shouldShowDealCosts = useMemo(() => {
    return materialsList && !!materialsList.materialsListMaterialIds?.length;
    // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useMemo has a missing dependency: 'materialsList'
  }, [materialsList?.materialsListMaterialIds?.length]);

  return (
    <div className="deal-materials-list">
      {shouldShowDealCosts && (
        <ResponsiveViewWrapper
          className="deal-totals-costs-container"
          downBreakpointSm={600}
          downBreakpointXs={450}
        >
          <div className="deal-totals-costs-container-inner">
            {shouldShowDealCosts && <DealCostsMargins dealId={dealId} />}
          </div>
        </ResponsiveViewWrapper>
      )}

      {!!deal?.materialsListId && (
        <ManageableMaterialsList
          materialsListId={deal?.materialsListId}
          dealContextId={dealId}
        />
      )}
    </div>
  );
};

export default DealMaterialsList;
